function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

/**
 * Replacement of HTMLImageElement with placeholder render props
 * to render in-place as the image source is being loaded
 */
const ImageWithPlaceholder = ({
  renderPlaceholder,
  ...imageProps
}) => {
  var _imageProps$style;

  const [loaded, setLoaded] = React.useState(false);

  const handleImageLoaded = e => {
    var _imageProps$onLoad;

    setLoaded(true);
    (_imageProps$onLoad = imageProps.onLoad) === null || _imageProps$onLoad === void 0 ? void 0 : _imageProps$onLoad.call(imageProps, e);
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("img", _extends({
    draggable: false
  }, imageProps, {
    style: { ...imageProps,
      display: loaded ? (_imageProps$style = imageProps.style) === null || _imageProps$style === void 0 ? void 0 : _imageProps$style.display : 'none'
    },
    onLoad: handleImageLoaded
  })), !loaded ? renderPlaceholder() : null);
};

export default ImageWithPlaceholder;